var React = require('react');

function FooterArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M5.17463 2.4685L1.89755 2.81558L1.66652 1.33348L5.35024 0.923016C6.01021 0.795808 6.68828 1.00789 7.18077 1.45413L7.20815 1.47894L7.23296 1.50632C7.67823 1.99774 7.89128 2.67459 7.76418 3.33465L7.09305 6.7503L5.60966 6.52769L6.21517 3.54928L1.38223 8.38223L0.321566 7.32157L5.17463 2.4685Z","fill":"white"}));
}

FooterArrow.defaultProps = {"width":"8","height":"9","viewBox":"0 0 8 9","fill":"none"};

module.exports = FooterArrow;

FooterArrow.default = FooterArrow;
